var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgPython = function SvgPython(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.525 3c-3.296 0-5.968 2.587-5.968 5.778v4h10.328v1.11H8.967C5.672 13.889 3 16.477 3 19.668v8.666c0 3.191 2.672 5.778 5.967 5.778h3.443v-4.889c0-3.19 2.671-5.778 5.967-5.778h11.016c2.789 0 5.05-2.188 5.05-4.889V8.778C34.443 5.587 31.77 3 28.475 3h-8.95Zm-1.377 7.111c1.14 0 2.065-.895 2.065-2 0-1.104-.925-2-2.066-2-1.14 0-2.065.896-2.065 2 0 1.105.925 2 2.066 2Z",
    fill: "url(#python_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.475 45c3.296 0 5.967-2.587 5.967-5.778v-4H24.114v-1.11h14.918c3.296 0 5.968-2.588 5.968-5.779v-8.666c0-3.191-2.672-5.778-5.968-5.778H35.59v4.889c0 3.19-2.672 5.778-5.967 5.778H18.606c-2.788 0-5.049 2.188-5.049 4.889v9.777c0 3.191 2.672 5.778 5.967 5.778h8.951Zm1.377-7.111c-1.14 0-2.065.895-2.065 2 0 1.104.924 2 2.065 2s2.066-.896 2.066-2c0-1.105-.925-2-2.066-2Z",
    fill: "url(#python_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "python_svg__a",
    x1: 18.721,
    y1: 3,
    x2: 18.721,
    y2: 34.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1565A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "python_svg__b",
    x1: 29.278,
    y1: 13.889,
    x2: 29.278,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C600"
  })))));
};

export default SvgPython;